import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("gd_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("gd_token", data.token);
    localStorage.setItem("gd_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", { session_id: sessionId });
    localStorage.setItem("gd_token", data.token);
    localStorage.setItem("gd_user", JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("gd_token");
    localStorage.removeItem("gd_user");
    setUser(null);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/me");
    localStorage.setItem("gd_user", JSON.stringify(data));
    setUser(data);
  };

  return (
    <AuthContext.Provider value={{ user, login, loginWithGoogle, logout, loading, setLoading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
